
import '../homePage/HomePage.css'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import React, { useEffect, useRef, useState } from "react";
import Faq from '../components/faq/Faq';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Navbar from '../components/navbar/Navbar'
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import Footer from "../components/footer/Footer";
import ApiService from '../../../config/api';
import { useNavigate } from "react-router-dom";
import PropertyInquiryModal from "../BuyPage/PropertyInquiryModal ";
import { GET_POPULAR_PROPERTY } from "../../../config/api";
import logo from "../../../assets/rating.png"
import { FaCheck, FaClock } from "react-icons/fa";
import CarouselFadeExample from '../../webpage/components/CarouselFadeExample';
import SearchBar from './SearchBar';
import PopularPropertiesCarousel from '../../../models/PopularPropertiesCarousel ';
import { BlogHome } from './BlogHome';


function VerticalMode({ image1, image2, image3, image4, image5, delay }) {

  const sliderRef = useRef(null);


  const settings = {
    arrows: false,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 4000,
    cssEase: "linear",
    pauseOnHover: true,

    dots: false,
    infinite: true,

    vertical: true,
    verticalSwiping: true,
    beforeChange: function (currentSlide, nextSlide) {
    },
    afterChange: function (currentSlide) {
    }
  };

  return (
    <div className="slider-container">
      <Slider {...settings} ref={sliderRef}>
        <div>
          <span className="wrapper"><img src={image1} className="mb-4 " alt="" /></span>
        </div>
        <div>
          <span className="wrapper"><img src={image2} className="mb-4 " alt="" /></span>
        </div>
        <div>
          <span className="wrapper"><img src={image3} className="mb-4 " alt="" /></span>
        </div>
        <div>
          <span className="wrapper"><img src={image4} alt="" className="mb-4" /></span>
        </div>
        <div>
          <span className="wrapper"><img src={image5} alt="" className="mb-4 " /></span>
        </div>

      </Slider>
    </div>
  );
}


const testimonials = [
  {
    name: "MOHAMMAD KHALID",
    text: "This website made finding the perfect property stress-free and efficient. The detailed listings and high-quality images were exactly what I needed to make an informed decision. Great service!",
    image: "https://static.vecteezy.com/system/resources/previews/022/127/318/non_2x/avatar-photo-placeholder-icon-of-a-man-in-a-shirt-and-tie-vector.jpg",
  },
  {
    name: "ARBAZ KHAN",
    text: "Being a first-time buyer, I was nervous about the process, but this website made everything so easy. The step-by-step guidance and market insights were invaluable. Thank you for helping me find my first home!",
  },
  {
    name: "ARSALAN KHAN",
    text: "I was impressed with the personalized recommendations I received. The team truly understood my needs and helped me find the ideal home for my family. Excellent support throughout the process!",
  },
  {
    name: "KHIZAR SAEED KHAN",
    text: "As a landlord, listing my property here was quick and simple. I found trustworthy tenants within days, and the support team was always available to help with any questions.",
  },
  {
    name: "MURTAZA MALIK",
    text: "The platform is user-friendly and loaded with great features. I especially loved the virtual tours—it felt like I was visiting the property in person! Highly recommend it to anyone looking for real estate solutions.",
  }
];

const HomePage = () => {
  const navigate = useNavigate();

  const [properties, setProperties] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);
  const [localities, setLocalities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(6);


  const getLocalities = async () => {
    try {
      const successResponse = await ApiService.get(`/localities`);
      if (!successResponse.data.error) {
        setLocalities(successResponse.data.meta);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


  const getDataFromServer = async () => {
    try {
      const successResponse = await ApiService.getAll(GET_POPULAR_PROPERTY);

      const { popularProperties } = successResponse.data;
      setProperties(popularProperties);

    } catch (error) {
      console.error('Error fetching popular properties:', error);
    }
  };

  useEffect(() => {
    getDataFromServer();
    getLocalities();
  }, []);

  const openInquiryModal = (propertyId) => {
    setSelectedPropertyId(propertyId);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleClick = (status) => {
    navigate(`/buyPage?projectStatus=${status}`);
  };

  const handleNavigate = (category) => {
    navigate(`/buyPage?category=${category}`);
  };
  const isMobile = window.innerWidth <= 576;
  return (

    <div className='background-main'>
      <Navbar className="" />


      {/* ------hero------------------ */}

      <div className="hero-fullscreen">
        <CarouselFadeExample />
      </div>

      <div className='hero d-flex align-items-center text-center'>
        <div className="container">
          <div className="row justify-content-center">
            <SearchBar />
          </div>
        </div>
      </div>

      <div
        className="hero d-flex align-items-center text-center position-relative"
        style={{ minHeight: "100px" }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 position-absolute top-100 start-50 translate-middle">
              <div className="d-flex justify-content-center gap-4 flex-wrap">
                <button
                  className="btn btn-custom project-btn"
                  onClick={() => handleClick("completed")}
                >
                  Completed Projects
                </button>
                <button
                  className="btn btn-custom project-btn"
                  onClick={() => handleClick("upcoming")}
                >
                  Upcoming Projects
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>



      {/*  New Card  added by Khalid 31/Dec/2024 */}

      <div>
        <PopularPropertiesCarousel
          properties={properties}
          navigate={navigate}
          openInquiryModal={openInquiryModal}
          logo={logo}
        />
      </div>

      <div className="container" style={{ maxWidth: "1250px", width: "100%" }}>
        <h3 className="mb-2 text-color mt-4">Localities You-May-like</h3>

        <div className="row">
          {loading
            ? Array(6)
              .fill()
              .map((_, i) => (
                <div className="col-6 col-md-4 col-lg-4 mb-2" key={i}>
                  <Skeleton height={150} className="rounded" />
                  <Skeleton width={`70%`} height={20} className="mt-2" />
                </div>
              ))
            : localities.slice(0, visibleCount).map((loc, index) => (
              <div className="col-6 col-md-4 col-lg-4 mb-2" key={index}
                onClick={() => navigate(`/buyPage?locality=${loc._id}`)}
                style={{ cursor: "pointer" }}
              >
                <div className="card border-0 text-center locality-card">
                  <img
                    src={loc.image}
                    alt={loc.name}
                    className="img-fluid rounded locality-img"
                    style={{ height: "150px", objectFit: "cover" }}
                  />
                </div>
                <p
                  className="mt-2 fw-bold"
                  style={{ color: "var(--bs-secondary)" }}
                >
                  {loc.name}
                </p>
              </div>
            ))}
        </div>

        {!loading && visibleCount < localities.length && (
          <div className="d-flex justify-content-end">
            <button
              className="btn-outline px-3 rounded-2 bg-transparent"
              style={{
                color: "var(--bs-accent)",
                border: "2px solid var(--bs-accent)",
              }}
              onClick={() => setVisibleCount(localities.length)}
            >
              See more
            </button>
          </div>
        )}
      </div>

      <div className="container" style={{ maxWidth: "1250px", width: "100%" }}>
        <h3 className="mb-2 text-color mt-4">Real Estate Investment</h3>
        <div className="row">
          <div className="col-6 col-md-4 col-lg-4 mb-2"
            style={{ cursor: "pointer" }}
            onClick={() => handleNavigate("RESIDENTIAL")}>
            <div className="card border-0 text-center locality-card1">
              <h4 style={{ color: "#F4EBD0" }}>Residential </h4>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-4 mb-2"
            style={{ cursor: "pointer" }}
            onClick={() => handleNavigate("COMMERCIAL")}>
            <div className="card border-0 text-center locality-card1">
              <h4 style={{ color: "#F4EBD0" }}>Commercial</h4>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-4 mb-2"
            style={{ cursor: "pointer" }}
            onClick={() => handleNavigate("PLOT")}>
            <div className="card border-0 text-center locality-card1">
              <h4 style={{ color: "#F4EBD0" }}>Land / Plots</h4>
            </div>
          </div>
        </div>
      </div>

      <BlogHome />

      <div className="container reviews ">
        <div className="row mt-5">
          <div className="col-lg-12 col-sm-12 col-md-12">
            <div className="explore-box text-color">
              <h3>
                Discover your dream home with our extensive real estate listings. From cozy apartments to luxurious villas, find properties that suit your lifestyle and budget. Start your journey to a new home today.
              </h3>
            </div>

          </div>
        </div>

      </div>


      {/* ----------------------------instance-valuation by Khalid-------------------------------*/}
      <div className="container  padding-box mt-4 mb-5 " >
        <div className=" row  rounded-4 box-color">

          <div className="col-lg-6 col-md-12 col-sm-12 valuation-module d-flex flex-column justify-content-center">
            <div className="">
              <h3 className='valuation-text'>Find Your Dream Home Today</h3>

            </div>
            <p className='valuation-text'>Finding a home that fits your lifestyle has never been easier. Browse through our curated selection of properties, and let us guide you to the home that aligns with your dreams and needs. Begin your search today. </p>

          </div>
          <div className="col-lg-6   carousal-wrapper">

            <span className='d-flex'>
              <VerticalMode image1="/assets/images/homePageImg/vc1.webp"
                image2="/assets/images/homePageImg/vc1.2.webp"
                image3="/assets/images/homePageImg/vc1.3.webp"
                image4="/assets/images/homePageImg/vc1.4.webp"
                image5="/assets/images/homePageImg/vc1.5.webp"
                delay={300}
              />

              <VerticalMode image1="/assets/images/homePageImg/vc2.webp"
                image2="/assets/images/homePageImg/vc2.2.webp"
                image3="/assets/images/homePageImg/vc2.3.webp"
                image4="/assets/images/homePageImg/vc2.4.webp"
                image5="/assets/images/homePageImg/vc2.5.webp"
                delay={300}
              />

              <VerticalMode image1="/assets/images/homePageImg/v3.webp"
                image2="/assets/images/homePageImg/vc3.2.webp"
                image3="/assets/images/homePageImg/vc3.3.webp"
                image4="/assets/images/homePageImg/vc3.4.webp"
                image5="/assets/images/homePageImg/vc3.5.webp"
                delay={2000}
              />

            </span>
          </div>

        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 flex items-center justify-center text-center m-auto">
            <div>
              <h2 className="font-bold text-white text-3xl mb-2 px-5">
                This is what other Owners & Dealers have to say...
              </h2>
              <p className="text-lg mb-4 text-white">
                We place huge value on strong relationships and have seen the benefit they bring to our business. Customer feedback is vital in helping us to get it right.
              </p>
            </div>
          </div>

          {/* Right Side Slider  added by Khalid 31/Dec/2024  */}
          <div className="col-12 col-md-6"
            style={{ height: "200px" }} >
            <Swiper
              spaceBetween={50}
              modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
              pagination={{ clickable: true }}
              scrollbar={{ draggable: true }}
              slidesPerView={1}
              // navigation={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              onSlideChange={() => console.log("slide change")}
              onSwiper={(swiper) => console.log(swiper)}
            >
              {testimonials.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div className="text-white p-6 text-center flex items-center justify-center"
                    style={{ height: "200px" }} >
                    <div>
                      <h3 className="font-bold text-2xl mb-2">{testimonial.name}</h3>
                      <div className="w-8 h-[2px] bg-white mx-auto mb-8"></div>
                      <p className="px-40 text-lg">{testimonial.text}</p>
                    </div>
                  </div>

                </SwiperSlide>
              ))}
            </Swiper>
          </div>

        </div>
      </div>


      {/* -----------------accordian by Khalid 07/Jan/2025 ---------------------- */}

      <div className='accordion mt-4'>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 ">
              <div className="mb-3 mt-3 "><h2>Why choose Eleganza</h2></div>

              <Faq></Faq>
            </div>
          </div>
        </div>
      </div>

      <PropertyInquiryModal open={modalOpen} handleClose={closeModal} propertyId={selectedPropertyId} />

      <Footer />

    </div >


  )
}

export default HomePage
